export default function RoleDescriptionBtn({ title, category, color }) {
    return (
        <div className="flex gap-2 w-full justify-center items-center">
            <span>{title}</span>
            <span style={{ color: color, backgroundColor: `${color}15`, padding: "2px 4px", borderRadius: "7px" }}>{category}</span>
        </div>
    )
}
